import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CaretDown, GitBranch } from "@phosphor-icons/react";

/** Desplegable para elegir qué versión de una fórmula ver, sin acumular versiones en el listado. */
export default function VersionSelector({ formula }) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const versions = formula.versions || [];
    const count = formula.version_count || versions.length || 1;

    useEffect(() => {
        const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", onClick);
        return () => document.removeEventListener("mousedown", onClick);
    }, []);

    if (count <= 1) {
        return <span className="mono text-xs text-[var(--ink-2)]">v{formula.version || 1}</span>;
    }

    const go = (e, id) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(false);
        navigate(`/formulas/${id}`);
    };

    return (
        <div className="relative inline-block" ref={ref} data-testid={`version-selector-${formula.id}`}>
            <button
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((o) => !o); }}
                className="inline-flex items-center gap-1 mono text-xs border hairline bg-white px-2 py-1 hover:bg-[var(--cream)]"
                data-testid={`version-selector-trigger-${formula.id}`}
            >
                <GitBranch size={11}/> v{formula.version || 1}
                <span className="text-[var(--ink-3)]">de {count}</span>
                <CaretDown size={10} className={`transition-transform ${open ? "rotate-180" : ""}`}/>
            </button>
            {open && (
                <div className="absolute right-0 z-20 mt-1 w-72 max-h-80 overflow-y-auto border hairline bg-white shadow-lg" data-testid={`version-selector-menu-${formula.id}`}>
                    {versions.map((v) => (
                        <button
                            key={v.id}
                            onClick={(e) => go(e, v.id)}
                            className={`w-full text-left px-3 py-2.5 border-b hairline last:border-b-0 hover:bg-[var(--cream)] ${v.id === formula.id ? "bg-[var(--cream)]" : ""}`}
                            data-testid={`version-option-${v.version}`}
                        >
                            <div className="flex items-center justify-between gap-2">
                                <span className="mono text-xs font-medium">v{v.version}{v.id === formula.id && <span className="ml-1 text-[var(--sage)]">· actual</span>}</span>
                                <span className="text-[10px] text-[var(--ink-3)]">{(v.created_at || "").slice(0, 10)}</span>
                            </div>
                            {v.change_summary && (
                                <p className="text-[11px] text-[var(--ink-2)] mt-1 line-clamp-2 leading-snug">{v.change_summary}</p>
                            )}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
